// =================================================================
// Engine: Gram-positive synergy mode (PSD §4.2 / TODO Task 3.4)
// Divided-dose regimen, Cmax 3–4 mg/L, Cmin < 1 mg/L.
// =================================================================
import { ok } from './types';
import { predictPeakTrough } from './traditional';
/** Divided-dose synergy regimen targeting Cmax 3–4, Cmin < 1. */
export function computeSynergyRegimen(agentParams, dosingWeightKg, kelPerHr, vdLkg, infusionDurationHr = 0.5) {
    const targetPeak = agentParams.synergyPeakTarget || 3.5;
    const intervalHr = 12; // divided dosing
    const vdL = vdLkg * dosingWeightKg;
    // maintenance = targetPeak × Vd × (1 − e^−kel×tau)
    const doseMg = targetPeak * vdL * (1 - Math.exp(-kelPerHr * intervalHr));
    const pt = predictPeakTrough(doseMg, kelPerHr, vdL, intervalHr, infusionDurationHr);
    if (!pt.ok)
        return pt;
    return ok({
        doseMg,
        intervalHr,
        predictedPeak: pt.value.peak,
        predictedTrough: pt.value.trough,
        peakMeetsTarget: pt.value.peak >= 3 && pt.value.peak <= 4,
        troughMeetsTarget: pt.value.trough < 1,
    });
}
//# sourceMappingURL=synergy.js.map